// store.js
import { reactive, ref } from "vue";
import { defineStore } from "pinia";
export const store = reactive({
    showSignUpModal: false,

    routeChange: "",
    toggleSignUp() {
        this.showSignUpModal = !this.showSignUpModal;
    },
    setRouteChange(payload) {
        this.routeChange = payload;
    }
});

export const useSidebarStore = defineStore("sidebar", () => {

    const contentSidebar = ref({
        show: false,
        sidebarName: null,
        data: null,
        postTags: null,
        slug: null
    });

    const toggleContentSidebarVisibility = (visibility) => {
        contentSidebar.value = { ...contentSidebar.value, show: visibility };
    };

    const setContentSidebarName = (Name) => {
        contentSidebar.value = { ...contentSidebar.value, sidebarName: Name };
    };

    const setContentSidebarTitle = (slug) => {
        contentSidebar.value = { ...contentSidebar.value, slug };
    };

    const setPostsTags = (tags) => {
        contentSidebar.value = { ...contentSidebar.value, postTags: [...tags] };
    };

    const setContentSidebarData = (payload) => {
        contentSidebar.value = { ...contentSidebar.value, data: payload };
    };


    return {
        contentSidebar,
        toggleContentSidebarVisibility,
        setContentSidebarName,
        setContentSidebarTitle,
        setPostsTags,
        setContentSidebarData
    };
});